module.exports =  {
  TITLE: {
    default: 'Rechercher un hôtel | Des dizaines de milliers d\'hôtels en ligne en Asie à réserver',
    detail: '|Réservation d\'hôtel',
  },
  hotel: {
    // Nouvelle traduction pour la recherche d'hôtels - Anglais
    ROOMS: 'Chambres',
    GUESTS: 'Clients',
    CHECK_IN_NUM: 'Clients',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Adulte',
    SUFFIX_ADULTS: 'Adultes',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Enfant',
    SUFFIX_CHILDREN: 'Enfants',
    CHILD_AGE: 'Âge de l\'enfant',
    NO_MATCH_TIPS: 'Le type de chambre ci-dessous ne correspond pas au nombre de chambres et de clients que vous avez sélectionné.',

    Book_Hotel: 'Réserver un hôtel',
    Select_your_destination: 'Sélectionnez votre destination',
    Please_enter_your_destination: 'Veuillez entrer votre destination/hôtel',
    Booked_up: 'Complet',
    Hotel_description: 'Description de l\'hôtel',
    Check_in_date: 'Date d\'arrivée',
    Check_out_date: 'Date de départ',
    Sold_out: 'Épuisé',
    Non_refundable: 'Non remboursable',
    reserve: 'Réserver',
    Pay_Online: 'Payer en ligne',
    Only_rooms_left_before: 'Il ne reste que ',
    Only_rooms_left_after: ' chambre(s)',
    Cancellation_Policy: 'Politique d\'annulation',
    See_all_prices_before: 'Voir tous les ',
    See_all_prices_after: 'prix',
    Estimated_time_of_arrival: 'Heure d\'arrivée estimée',
    make_your_schedule_well_planned: 'L\'heure est pour le fuseau horaire local, veuillez bien planifier votre emploi du temps et arriver à l\'heure.',
    Hotel_Not_Found: 'Hôtel non trouvé',
    Please_change_your_search: 'Veuillez changer votre recherche',
    Submit_an_application: 'Soumettre une demande',
    Hotel_Confirmation: 'Confirmation d\'hôtel',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Nuitées',
    Hotel_Booking_Number: 'Numéro de réservation d\'hôtel',
    Online_Payment: 'Paiement en ligne',
    The_guest_Room_before: 'Le client [Chambre',
    The_guest_Room_after: ']',
    Contact_number: 'Numéro de contact',
    Bring_all_valid_IDs: 'Veuillez apporter toutes les pièces d\'identité valides de tous les clients lors de l\'enregistrement.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'Hôtels trouvés',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Hôtels présentés (',
    Hotels_Presented_after: ' au total)',
    Please_change_the_dates: 'Chambre non disponible à vos dates, veuillez changer les dates.',
    Login: 'Connectez-vous sur l\'application pour réserver un hôtel',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Nuits au total',
    Location: 'Emplacement',
    Pictures: 'Photos',
    Description: 'Description',
    Policy: 'Politique',
    Check_in_and_check_out_time: 'Heure d\'arrivée et de départ',
    Check_in_and_Check_out_before: 'Arrivée : après ',
    Check_in_and_Check_out_center: 'Départ : avant ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Heure d\'arrivée',
    Check_out_time: 'Heure de départ',
    Facility_Service: 'Équipements et services',
    Payment_methods: 'Méthodes de paiement acceptées par l\'hôtel',
    Hotel_Address: 'Adresse de l\'hôtel',
    Pay_online: 'Payer en ligne',
    Pay_offline: 'Payer sur place',
    Night_stay_before: '',
    Night_stay_after: '-Nuitée,',
    Rooms_total_before: 'Chambres',
    Rooms_total_after: 'au total',
    Guest_name_must_be_provided: 'Le nom complet du client doit être fourni.',
    Please_fill_in_your_contact_number: 'Veuillez indiquer votre numéro de contact',
    Select_estimated_time_of_arrival: 'Sélectionnez l\'heure d\'arrivée estimée',
    Number_of_Rooms: 'Nombre de chambres',
    Maximum_guests_per_room_before: 'Maximum de ',
    Maximum_guests_per_room_after: ' clients par chambre',
    Many_Rooms: ' Chambres',
    Service_Fee_Included: '(Taxe et frais de service inclus)',
    Last_Name: 'Nom de famille',
    First_Name: 'Prénom ',
    Room: 'Chambre',
    Additional_Tax: 'Taxe supplémentaire',
    Please_inform_the_hotel: 'Si vous prévoyez d\'arriver après l\'heure d\'arrivée estimée, veuillez en informer l\'hôtel à l\'avance.',
    Please_inform_the_hotel_first: 'Arriver à l\'hôtel après l\'heure d\'arrivée estimée sans contacter l\'hôtel à l\'avance affectera la disponibilité de la chambre et du dîner. Veuillez d\'abord informer l\'hôtel pour confirmer la disponibilité dans de telles circonstances.',
    Booking_Cancellation: 'Annulation de la réservation',
    Reason_of_Cancellation: 'Raison de l\'annulation',
    Incorrect_Information_Filled: 'Informations incorrectes saisies',
    Itinerary_Changed: 'Itinéraire modifié',
    Lower_price_on_other_APP: 'Prix plus bas sur une autre application',
    Low_quality_hotel: 'Hôtel de basse qualité',
    Book_at_a_lower_price: 'Réservez à un prix inférieur à la réception',
    Other: 'Autre',
    Please_write_your_reason: 'Veuillez indiquer votre raison',
    After_cancellation_done: 'Après l\'annulation, le paiement sera restitué au payeur d\'origine dans un délai de 3 jours ouvrables.',
    How_to_fill_in_the_guest_name: 'Comment remplir le nom du client',
    It_should_be_exactly_the_same: 'Veuillez fournir le nom du client en lettres anglaises pour la réservation d\'hôtel. Il doit être exactement le même que le certificat présenté lors de l\'enregistrement.',
    How_to_fill_in_a_Chinese_name: 'Comment remplir un nom chinois:',
    How_to_fill_in_a_English_name: 'Comment remplir un nom anglais',
    For_example: 'Par exemple : Si votre nom chinois est “韩梅梅”, le nom de famille est "Han", le prénom est "Meimei".',
    No_specical_characters: 'Ne saisissez aucun chiffre ou caractère spécial. ',
    Name_rule_first: 'Le nom de famille vient en premier, suivi du prénom, et s\'il y a un deuxième prénom, il est suivi d\'un espace derrière les deux noms. ',
    Name_rule_second: 'Par exemple : Green / Jim Stephanie',
    Details: 'Détails',
    Pay_now: 'Payer maintenant',
    Hotel: 'Hôtel',
    Check_in: 'Enregistrement',
    Car: 'Voiture',
    All_bookings: 'Toutes les réservations',
    All: 'Toutes',
    PROMPT: 'Attention',


    Search: 'Rechercher',
    COST_DESCRIPTION: 'Détail du prix',
    TOTAL: 'Total',
    SEE_ORDER_INFO_TO: 'Payer',
    KONW: 'Compris',
    BOOKING_INFORMATION: 'Informations importantes',
    Book_Now: 'Payez maintenant',
    MAP: 'Carte',
    CONTACT_INFORMATION: 'Coordonnées',
    LOADING: 'Chargement...',
    SORT_FILTER: 'Trier/Filtrer',
    SCREENING: 'Filtrer',
    SEQUENCE: 'Trier',
    PHONE_ASK: 'Appelez-nous',
    ABOVE: '',
    SUBMINT_ORDER: 'Soumettre',
    OK: 'OK',
    Order_detail: 'Détails de la commande',
    BOOKING_INFO: 'Infos de réservation',
    PAYMENT_AMOUNT: 'Montant du paiement',
    Order_time: 'Heure de réservation',
    ORDER_NUMBERS: 'Numéro de réservation',
    PAY_TYPE: 'Moyen de paiement',
    BALANCE: 'Solde',
    CURRENT_BALANCE_BEGIN: 'Solde',
    OVERPLUS_BALANCE_BEGIN: 'Restant',
    OTHER_PAYMENT: 'Autres moyens de paiement',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat Payment',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'En cliquant sur "Payer maintenant", vous acceptez les conditions de Baigolf ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《Contrat de service》',
    PAYMENT_ORDER: 'Paiement de la réservation',
    Total_pay: 'Montant dû',
    PAY_SUCCESS: 'Paiement accepté',
    CHECK_THE_ORDER: 'Vérifier la commande',
    BACK_TO_INDEX: 'Retour à l\'accueil',
    CANCEL: 'Annuler',
    RECOMMED: 'Recommander',
    PRICE: 'Prix',
    HIGH: 'Élevé',
    LOW: 'Faible',
    RESET: 'Réinitialiser',
    SELECT_TIME: 'Sélectionner la date',
    Hotel_guest: 'L\'invité',
    Select: 'Veuillez sélectionner',
    Emial_address: 'Veuillez saisir l\'adresse e-mail',
    Booking_explan: 'Informations sur la réservation',
    VIEW_MORE: 'Voir plus',
    COLLAPSE: 'Masquer',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'Enregistrement',
    TOURISM_LEAVE_HOTEL: 'Check-out',
    arrive: 'Destination',
    Room_description: 'Description de la chambre',
    Meals: 'Repas',
    Room_Type: 'Type de chambre',
    BOOKING_EXPLANATION: 'Informations sur la réservation',
    BOOKING_BUTTON: 'Réserver',
    REMIND_SUBMIT_ORDER: 'Continuer',
    login_now: 'Les réservations d\'hôtel nécessitent une connexion, vous connectez-vous maintenant?',
    the_real_scene: 'Les images sont uniquement à titre de référence et sont soumises à la scène réelle.',
    Bed: 'Lit',
    Rooms: 'Chambre',
    Room_rate: 'Tarif de la chambre',
    notified_by_SMS: 'Après la réservation réussie, vous serez informé par SMS',
    email_notifications: 'Utilisé pour recevoir des notifications par e-mail',
    Booking_deadline: 'Date limite de réservation',
    Child: 'Enfant',
    Additional_notes_about_payment: 'Remarques supplémentaires sur le paiement',
    Nights: 'Nuits',
    Minimum_nights_before: 'Minimum',
    Minimum_nights_after: 'nuits',
    Size: 'Taille',
    Guests: 'Clients',
    Room_rate_1: 'Tarif de la chambre',
    Tax_service_fee: 'Taxe/frais de service',
    Pay_now_1: 'Payer maintenant',
    Filter: 'Filtrer',
    Room_rate2: 'Tarif de la chambre',
    Show_on_map: 'Afficher sur la carte',
    Detail: 'Détail',
    Room_Detail: 'Détail',

    TAXES_INCL: 'Taxes incluses',
    SEARCH_EMPTY_TIP: 'Désolé, aucune disponibilité à la date sélectionnée, vous pouvez : rechercher des dates ou des hôtels alternatifs',
    severalNight: 'Nuits',
    immediateBooking: 'Réservez maintenant',
    Refundable: 'Remboursable',
    MORE: 'Plus',
    adultsCompany: 'adultes',
    ServiceTerms: 'Services et conditions',
    roomPlan: 'Plan',
    guestRoom: 'Chambre',
    searchAgain: 'Rechercher à nouveau',
    roomNight: 'chambre/nuit',

    NAME_TXT: 'Nom',
    HOLDER_NAME: 'Nom du titulaire de la carte',
    EXPIRATION_DATE: 'Date d\'expiration',
    FORMAT_TXT: 'Format',
    SECURITY_CODE: 'Code de sécurité',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: 'Les 3 chiffres au dos de la carte.',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '4 chiffres à l\'avant de la carte',
    ENTER_COMPLETE_CARD_NUM: 'Veuillez entrer un numéro de carte complet.',
    PLEASE_ENTER_HOLDER_NAME: 'Entrez le nom du titulaire de la carte',
    ENTER_SECURITY_CODE: 'Entrez le code de sécurité',
    ENTER_EXPIRATION_DATE: 'Entrez la date d\'expiration',
    ROOM_DETAILS: 'Détails de la chambre',
    CONDITION_CANCEL: 'Remboursable',
    CHOOSE_PAYMENT_METHOD: 'Paiement',
    ORDER_TOTAL_LUMP: 'Montant total',
    CREDIT_CARD_NUM: 'Numéro de carte de débit/crédit',
    MAINLAND_CARD_ONLY: 'Carte bancaire émise en dehors de la Chine continentale uniquement.',
    SHUT_DOWN: 'Fermer',
    PROVIDER_FROM_CHINA_BANK: 'Service de paiement fourni par la B.O.C',

    COUPON: 'Coupon',
    APPLY_A_COUPON: 'Appliquer un coupon',
    NO_USE: 'Non applicable à cette offre.',
    Discard: 'Rejeter',
    REDEEM: 'Échanger',
    EMPTY_COUPON: 'Veuillez saisir le code promotionnel',
    NOTICE_COUPON: 'Un seul coupon peut être échangé pour chaque réservation ; le coupon sera échangé après la soumission de la réservation.',
    BREAKFAST_INCLUDE: 'petit-déjeuner inclus',
    BREAKFAST_EXCLUDE: 'petit-déjeuner non inclus',
    DOUBLE_BED: 'lit double',
    TWIN_BED: 'lits jumeaux',
    FREE_CANCEL: 'annulation gratuite',
    MEALS: 'repas',
    EVALUATION: 'Avis',
    FEATURED_REVIEWS: 'Avis en vedette',
    ALL_REVIEWS: 'Tous les avis',
    OVERALL_EVALUATION: 'Avis global',
    ANONYMOUS: 'Anonyme',
    EVAL_GENERAL_LIST_1: 'Mauvais',
    EVAL_GENERAL_LIST_2: 'Passable',
    EVAL_GENERAL_LIST_3: 'Moyen',
    EVAL_GENERAL_LIST_4: 'Bon',
    EVAL_GENERAL_LIST_5: 'Excellent',
    MAX_IMAGES_WITH_NINE: 'Un maximum de 9 images peut être sélectionné.',
    GRADE_EVAL: 'Veuillez sélectionner une note globale',
    DISTANCE_FILTER: 'distance proche-éloignée',
    EDIT_EVALUATION: 'Donner des commentaires',
    GO_TO_EVAL: 'Donner des commentaires',
    EVAL_POINTS_AWARD: 'De bons commentaires peuvent gagner 1000 points, 1000 points = 10 RMB',
    NEARBY_LIKE_HOTEL: 'Hôtel similaire à proximité',
    DISTANCE_HOTEL: 'à l\'hôtel',
    PLEASE_ENTER_COMMENT: 'commentaires',
    AWARD_POINTS_TIPS: 'Les meilleurs commentaires peuvent obtenir 1000 points, 1000 = 10 RMB',
    NO_SHOW_ANONYMOUS_AVATAR: 'Les commentaires anonymes ne montreront pas votre logo et votre nom',
    LOCATION: 'emplacement',
    FACILITY: 'installation',
    SERVICE: 'service',
    HEALTH: 'propreté',
    LANGUAGE_SELECT: 'langue',
    LIMIT_COMMENT_TXT: 'L\'avis doit comporter entre 5 et 2000 caractères',
    SHARE_MEDIA: 'Partager des photos et des vidéos',
    SETTLEMENT_FEEL: 'Commentaires',
    SUBMIT_EVAL: 'Confirmer',
    HOTEL_STR: 'Détails',
    EVAL_NUM_AFTER: 'avis',
  },
  header: {
    SKIING: 'Station de ski',
    header_internal_call: 'Chine continentale :',
    header_abroad_call: 'International :',
    header_app_download: 'Application mobile',
    service_telephone: 'Service client',
    account_number: 'Compte',
    if_bg_user: 'Pas encore membre BaiGolf ?',
    home: 'Accueil',
    hotel: 'Hôtel',
    Golf: 'Golf',
    PLAY_STAY: 'Séjour & Golf',
    RENT_CAR_HOME: 'Voiture',
    center_user: 'Espace Membre',
    header_my_order: 'Mes Réservations',
    header_notmember_order: 'Réservations en tant qu\'invité',
    header_edit_password: 'Changer de mot de passe',
    header_logout: 'Déconnexion',
    header_login: 'Connexion',
    header_register: 'S\'inscrire',
    header_point: 'Mes Points',
    header_all_language: 'Toutes les langues',
    down_load_app: 'Scannez le code QR pour télécharger',
    login_discount_tip: 'Connectez-vous pour gagner des bonus et profiter de vos avantages exclusifs',
    currency_balance_limit: 'La devise actuelle a encore un solde, impossible de changer de devise'
  },
  footer: {
    footer_partner: 'Partenaires',
    footer_about_us: 'À propos de nous',
    footer_about_baigolf: 'À propos de BaiGolf.com',
    footer_privacy_policy: 'Politique de confidentialité BaiGolf.com',
    footer_use_of_terms: 'Conditions de service BaiGolf.com',
    footer_contact_us: 'Nous contacter',
    footer_sitemap: 'Plan du site',
    footer_use_of_question: 'FAQ',
    footer_ios_system: 'iOS',
    footer_android_system: 'Android',
    footer_app_load: 'Téléchargement de l\'application',
    footer_sina_weibo: 'Sina Weibo',
    footer_tencent_weibo: 'Microblog Tencent',
    footer_share_to: 'Partager',
    copyright1: 'Guangzhou BaiGolf Information Technology Co., Ltd. Droits d\'auteur ',
    copyright2: 'Yue ICP Enregistrement n°14070002',
    news_center: 'Centre d\'actualités',
    about_baigolf: 'À propos de BaiGolf',
    help: 'Aide',
    management_system: 'Système de gestion BG Golf (BGMS)',
    wechat_official_account: 'Compte officiel WeChat',
    download_baiGolf_app: 'Télécharger l\'application BaiGolf',
    privacy_policy: 'Politique de confidentialité',
    use_of_terms: 'Conditions de service',
    footer_integral: 'Politique de points',
    footer_reserve: 'Politique de réservation',
    footer_abroad_call: 'International',
    footer_internal_call: 'Chine continentale'
  }
}



// WEBPACK FOOTER //
// ./src/lang/french.js